<template>
    <div class="related">
        <div class="related-title">{{pageTitle}}</div>
        <table class="detail-table" border="1" cellspacing="0" cellpadding="0" v-if="pageType == 1 || pageType == 2">
            <tr>
                <th style="width: 50px;">序号</th>
                <th style="width: 200px;">项目编号</th>
                <th style="min-width: 100px;">时间</th>
                <th style="min-width: 460px;">项目名称</th>
                <th style="min-width: 150px;">审核类型</th>
                <th style="min-width: 160px;">建设单位</th>
                <th style="min-width: 150px;">审批单位</th>
            </tr>
            <tr v-for="(list, i) in paginatedData" :key="list.id">
                <td>{{ i + 1 + (currentPage - 1) * pageSize }}</td>
                <td style="white-space: nowrap;">{{ list.projectCode }}</td>
                <td>{{ list.date.slice(0, 10) }}</td>
                <td><span class="active-color" @click="handlerLinkTo(list)">{{ list.projectName }}</span></td>
                <td>{{ list.title }}</td>
                <td>{{ list.companyName }}</td>
                <td>{{ list.approveUnitName }}</td>
            </tr>
        </table>
        <table class="detail-table" border="1" cellspacing="0" cellpadding="0" v-if="pageType == 3"> <!--产业链上游项目-->
            <tr>
                <th style="width: 50px;">序号</th>
                <th style="width: 200px;">项目名称</th>
                <th style="min-width: 100px;">中选机构</th>
                <th style="min-width: 460px;">项目规模</th>
                <th style="min-width: 150px;">城市</th>
                <th style="min-width: 160px;">合同时间</th>
            </tr>
            <tr v-for="(list, i) in paginatedData" :key="list.id">
                <td>{{ i + 1 + (currentPage - 1) * pageSize }}</td>
                <td style="white-space: nowrap;"  class="active-color" @click="handleViewDetail(list)">{{ list.projectName }}</td>
                <td>{{ list.bidAgentName || '-' }}</td>
                <td><span>{{ formatScaleValue(list.restrictions) || '-'  }}</span></td>
                <td>{{ list.province }}{{ list.city }}{{ list.county }}</td>
                <td> {{ list.contractDate || '-' }}</td>
            </tr>
        </table>
        <div class="pagination-wrapper text-right my-2">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background />
        </div>

    </div>
</template>

<script>
export default {

    data() {
        return {
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            paginatedData: [], // 当前页要展示的数据 (真正绑定给表格的数据)
            rawData: [], // 原始数据
        }
    },
    props: {
        relatedByData: {
            type: Array,
            default: () => []
        },
        pageTitle: {
            type: String,
            default: '关联项目'
        },
        pageType: {
            type: Number,
            default: 1
        }
    },
    watch: {
        relatedByData: {
            immediate: true,  // 立即执行一次，解决初始化问题
            handler(newVal) {
                this.rawData = newVal || [];
                this.total = this.rawData.length;
                this.currentPage = 1;  // 数据变化时重置到第一页
                this.updatePaginatedData();
            }
        }
    },
    created() {
        this.rawData = this.relatedByData;
        
    },
    mounted() {
        this.total = this.relatedByData.length;
        this.updatePaginatedData();
    },
    methods: {
        //详情跳转
        handleViewDetail(row) {
            // console.log(row.detail == 'Detail');
            // return;
            if(row.detail == 'Detail'){
                this.handlerLinkLocal('/agencyService/detail?id=' + row.id);
            }else if(row.detail == 'DetailGD'){  //广东
                this.handlerLinkLocal('/agencyService/detailGD?id=' + row.id);
            }else if(row.detail == 'DetailSZ'){  //深圳
                this.handlerLinkLocal('/agencyService/detailSZ?id=' + row.id);
            }else{  //其他
                this.handlerLinkLocal('/agencyService/detail?id=' + row.id);
            }
            
        },
        formatScaleValue(str) {
            // 如果为空或者没有值，直接返回 '-'
            if (!str) return '-';

            // 使用正则匹配全角或半角括号内的内容
            // 匹配规则：找到 （ 或 ( ，捕获中间的内容，直到遇到 ） 或 )
            const match = str.match(/[（(](.+?)[）)]/);

            if (match && match[1]) {
                // match[1] 就是括号里的内容，例如 "¥270,000,000元" 或 "1,000平方米"
                let result = match[1];

                // 去掉开头的货币符号 (¥, ￥, $ 等)
                result = result.replace(/^[¥￥$]/, '');

                return result;
            }

            // 如果没有匹配到括号（比如输入的是 "其他"），则返回 '-'
            return '-';
        },
        handlerLinkTo(list) {
            switch (list.dataType) {
                case 1:
                    this.handlerLinkLocal('/examineNotice/detail?id=' + list.id);
                    break;
                case 2:
                    this.handlerLinkLocal('/ApprovalNotice/detail?id=' + list.id);
                    break;
                case 3:
                    this.handlerLinkLocal('/RecordPublic/detail?id=' + list.id);
                    break;
                case 4:
                    this.handlerLinkLocal('/EiaReport/detail?id=' + list.id);
                    break;
                case 5:
                    this.handlerLinkLocal('/EnergyNotice/detail?id=' + list.id);
                    break;
                case 6:
                    this.handlerLinkLocal('/LandPreapproval/detail?id=' + list.id);
                    break;
                case 7:
                    this.handlerLinkLocal('/landSearch/detail?id=' + list.id);
                    break;
                case 8:
                    this.handlerLinkLocal('/LandPermit/detail?id=' + list.id);
                    break;
                case 9:
                    this.handlerLinkLocal('/ConstructionPermit/detail?id=' + list.id)
                    break;
                case 10:
                    this.handlerLinkLocal('/tenderingBidding/detail?id=' + list.id);
                    break;
                case 11:
                    this.handlerLinkLocal('/buildPermit/detail?id=' + list.id);
                    break;
            }
        },
        // 2. 核心分页逻辑：计算并截取当前页的数据
        updatePaginatedData() {
            // 计算起始索引 (例如：第2页，每页100条 -> 从索引100开始)
            const start = (this.currentPage - 1) * this.pageSize;
            // 计算结束索引 (例如：从100开始，取100条 -> 到索引200结束，不包含200)
            const end = start + this.pageSize;

            // 使用 slice 截取数组
            this.paginatedData = this.rawData.slice(start, end);
            console.log('pageType', this.pageType);
            console.log('截取数组', this.paginatedData);
        },
        // 3. 每页条数改变时触发 (例如从100条切换到50条)
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.currentPage = 1; // 重置回第一页
            this.updatePaginatedData();
        },
        // 4. 当前页码改变时触发 (点击页码按钮)
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.updatePaginatedData();
        },
    },
}
</script>

<style lang="scss" scoped>
.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        text-align: center;
    }
}
</style>